export default "__VITE_ASSET__JGWKhr4s__"